(ns teamoesterreich.admin-mode.navigation.drawer
  (:require [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.admin-mode.data.webSelection :as d-webSelection]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.brightness-7 :as ic-bright]
            [reagent-material-ui.icons.bookmark :refer [bookmark]]
            [reagent-material-ui.icons.group :refer [group]]
            [reagent-material-ui.icons.help :refer [help]]
            [reagent-material-ui.icons.amp-stories :refer [amp-stories]]
            [reagent-material-ui.icons.warning :refer [warning]]
            [reagent-material-ui.icons.menu :refer [menu]]
            [reagent-material-ui.icons.map :refer [map]]
            [reagent-material-ui.icons.person :refer [person]]
            [reagent-material-ui.icons.warning :refer [warning]]
            [reagent-material-ui.icons.alarm :refer [alarm]]
            [reagent-material-ui.icons.filter :as ic-filter]
            [reagent-material-ui.icons.search-outlined :refer [search-outlined]]
            [reagent-material-ui.icons.map-outlined :refer [map-outlined]]
            [reagent-material-ui.icons.lock-open :refer [lock-open]]
            [reagent-material-ui.icons.format-align-left :refer [format-align-left]]
            [reagent-material-ui.icons.format-line-spacing :refer [format-line-spacing]]
            [reagent-material-ui.icons.question-answer :refer [question-answer]]
            [reagent-material-ui.icons.chevron-left :refer [chevron-left]]
            [reagent-material-ui.icons.chevron-right :refer [chevron-right]]
            [reagent-material-ui.icons.assessment :refer [assessment]]
            ))

(defonce EVENT_CATEGORY_CLASSIC "EINSATZ")
(defonce EVENT_CATEGORY_ONLINE "ONLINE")
(defonce EVENT_CATEGORY_CAN_YOU "CAN_YOU")

(defn actual-tom-selection-button []
  (let [!actual-user (r/cursor vstate/app-state [:actual-user])
        !selectionLists (r/cursor vstate/app-state [:selected-elements :lists])
        !selectionLists-loaded (r/cursor vstate/app-state [:selected-elements :lists-loaded])

        !selected-uuid (r/cursor vstate/app-state [:selected-elements :list-uuid])

        !selected (r/cursor vstate/app-state [:selected-elements :selected])
        !selection-loaded (r/cursor vstate/app-state [:selected-elements :loaded])
        !selection-uuid (r/cursor vstate/app-state [:selected-elements :list-uuid])]
    (fn []
      (when-not (and @!selectionLists-loaded @!selection-uuid)
        (d-webSelection/get-selections (:tom-id @!actual-user)
                                       (fn [response]
                                         (log/debug "!selectionLists-loaded " (clj->js response) (ffirst response))
                                         (reset! !selectionLists response)
                                         (reset! !selectionLists-loaded true)
                                         (when-not @!selection-uuid (reset! !selection-uuid (ffirst response)))
                                         )))
      (when (and (not @!selection-loaded) @!selection-uuid)
        (d-webSelection/get-user @!selection-uuid
                                 (fn [response]
                                   (log/debug "!selection-loaded " response (ffirst response))
                                   (reset! !selected response)
                                   (reset! !selection-loaded true)
                                   )))
      [mui/list-item-text {:class ""} "Aktuelle Auswahl (" (if @!selected (count (filter second @!selected))) ")" [:br]
       [:div {:style {:display "inline_block" :overflow "hidden" :maxWidth "150px" :color "#0054ff"}
              :title (get-in @!selectionLists [@!selected-uuid :webUserSelection-name])} "`" (get-in @!selectionLists [@!selected-uuid :webUserSelection-name]) "`"]])))

(defn actual-user-button []
  (let [!selected (r/cursor vstate/app-state [:selected-tomId])]
    (fn []
      (when @!selected
        [mui/list-item
         {:class   "admin-menu-item" :button true
          :onClick #(a/open-user-view @!selected)}
         [mui/list-item-icon [person {:style {:color "darkred"}}]]
         [mui/list-item-text {:class ""} "Mitglied (" @!selected ")"]]))))

(defn actual-event-selection-button []
  (let [!selected (r/cursor vstate/app-state [:selected-event])]
    (fn []
      (when @!selected
        [mui/list-item
         {:class   "admin-menu-item" :button true
          :onClick #(a/open-event-view @!selected)}
         [mui/list-item-icon [map {:style {:color "darkred"}}]]
         [mui/list-item-text {:class ""} "Einsatz " (when-let [t (:crowdtaskerEvent-toeEventId @!selected)] (str "(" t ")")) [:br]
          [:div {:style {:display "inline_block" :overflow "hidden" :maxWidth "150px" :color "#0054ff"}
                 :title (:crowdtaskerEvent-name @!selected)} "`" (:crowdtaskerEvent-name @!selected) "`"]]
         ]
        ))))

(defn actual-event-alarm-selection-button []
  (let [!selected (r/cursor vstate/app-state [:selected-alarm])]
    (fn []
      (when @!selected
        [mui/list-item
         {:class   "admin-menu-item" :button true
          :onClick #(a/open-alarm-view (:eventAlarm-uuid @!selected))}
         [mui/list-item-icon [alarm {:style {:color "darkred"}}]]
         [mui/list-item-text {:class ""} "Alarmierung " [:br]
          [:div {:style {:display "inline_block" :overflow "hidden" :maxWidth "150px" :color "#0054ff"}
                 :title (str "`" (:eventAlarm-name @!selected) "`")}
           (str "`" (:eventAlarm-name @!selected) "`")]]
         ]
        ))))

(defn actual-can-you-event-selection-button []
  (let [!selected (r/cursor vstate/app-state [:selected-canyou])]
    (fn []
      (when (and @!selected (= (:crowdtaskerEvent-category @!selected) EVENT_CATEGORY_CAN_YOU))
        [mui/list-item
         {:class   "admin-menu-item" :button true
          :onClick #(a/set-page :can-you-overview)}
         [mui/list-item-icon [alarm {:style {:color "darkred"}}]]
         [mui/list-item-text {:class ""} "Anfrage " (when-let [t (:crowdtaskerEvent-toeEventId @!selected)] (str "(" t ")")) [:br]
          [:div {:style {:display "inline_block" :overflow "hidden" :maxWidth "150px" :color "#0054ff"}
                 :title (:crowdtaskerEvent-name @!selected)} "`" (:crowdtaskerEvent-name @!selected) "`"]]
         ]
        ))))

(defn actual-training-selection-button []
  (let [!selected (r/cursor vstate/app-state [:selected-training])]
    (fn []
      (when @!selected
        [mui/list-item
         {:class   "admin-menu-item" :button true
          :onClick #(a/set-page :trainingEvent-overview)}
         [mui/list-item-icon [map {:style {:color "darkred"}}]]
         [mui/list-item-text {:style {:overflow "hidden" :width "150px"}} "Veranstaltung " [:br] "(" (or (:trainingEvent-name @!selected)) ")"]
         ]
        ))))




(defn drawer-menu []
  (let [!load-state (r/cursor vstate/app-state [:load-state])
        !show-menu (r/cursor vstate/app-state [:show-menu])
        !drawer-menu (r/cursor vstate/app-state [:show-menu])
        ]
    (fn []
      [mui/drawer
       {:anchor  "left"
        :variant "persistent"
        :style   {:width "240px"}
        :open    @!show-menu
        }
       [:div
        [:div {:style {:width "240px"}}
         [:h2
          [mui/icon-button
           {:edge    "start" :aria-label "drawer-menu"
            :onClick #(reset! !drawer-menu (not @!drawer-menu))} (if @!drawer-menu [chevron-left] [chevron-right])
           ]
          " Admin Menu"]]
        ]

       (when (= :finished @!load-state)
         [:div
          [mui/list
           [mui/list-item
            {:class   "admin-menu-item" :button true
             :onClick #(a/set-page :default)}
            [mui/list-item-icon [info]]
            [mui/list-item-text {:class ""} "Startseite"]]]

          (when (d-rights/allow-admin-for d-rights/CONTENT)
            [:div {:style {:background-color "#fdffe6"}}
             [mui/divider]

             [:h4 " Inhalte"]
             [mui/list
              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :blog-list)}
               [mui/list-item-icon [bookmark]]
               [mui/list-item-text {:class ""} "Artikel"]]

              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :news-list)}
               [mui/list-item-icon [amp-stories]]
               [mui/list-item-text {:class ""} "Mitglieder News"]]

              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :warning-list)}
               [mui/list-item-icon [warning]]
               [mui/list-item-text {:class ""} "RK Warnungen"]]
              ]])

          (when (d-rights/allow-admin-for d-rights/CONTENT)
            [:div {:style {:background-color "#fee6ff"}}
             [mui/divider]
             [:h4 " Vorsorge Fragebögen"]
             [mui/list
              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :questionnaire-list)}
               [mui/list-item-icon [question-answer]]
               [mui/list-item-text {:class ""} "Fragebögen"]]
              ]])

          (when (or (d-rights/allow-admin-for d-rights/USER) (d-rights/allow-admin-for d-rights/USER_SEARCH))
            [:div {:style {:background-color "#edfff9"}}
             [mui/divider]
             [:h4 " Personen"]
             [mui/list
              ;[mui/list-item
              ; {:class "admin-menu-item" :button true
              ;  :onClick #(a/set-page :dashboard)}
              ; [mui/list-item-icon [warning]]
              ; [mui/list-item-text {:class "" } "Mein Cockpit"]]

              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :map-list)}
               [mui/list-item-icon [menu]]
               [mui/list-item-text {:class ""} "Mitglieder-Schnellsuche"]]

              [actual-user-button]
              ]])

          (when (or (d-rights/allow-admin-for d-rights/USER) (d-rights/allow-admin-for d-rights/USER_SEARCH))
            [:div {:style {:background-color "#f4ffff"}}
             [mui/divider]
             [:h4 " Personen Aktionen"]
             [mui/list

              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :toe-list)}
               [mui/list-item-icon [search-outlined]]
               [mui/list-item-text {:class ""} "Mitglieder-Suche"]]

              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :map-search)}
               [mui/list-item-icon [map-outlined]]
               [mui/list-item-text {:class ""} "Karte Adressen Suche"]]
              ]

             [mui/list-item
              {:class   "admin-menu-item" :button true
               :onClick #(a/set-page :selection-list)}
              [mui/list-item-icon [ic-filter/filter]]

              [actual-tom-selection-button]
              ]])

          (when (d-rights/allow-admin-for d-rights/CLASSIC)
            [:div {:style {:background-color "#ffc6c6"}}
             [mui/divider]
             [:h4 " Einsatz"]
             [mui/list


              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :event-list)}
               [mui/list-item-icon [map]]
               [mui/list-item-text {:class ""} "Einsatzliste"]]

              [actual-event-selection-button]

              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :event-alarm)}
               [mui/list-item-icon [alarm]]
               [mui/list-item-text {:class ""} "Alarmierungsliste"]]
              [actual-event-alarm-selection-button]

              ]])


          (when (d-rights/allow-admin-for d-rights/TRAINING)
            [:div {:style {:background-color "#fdffe6"}}
             [mui/divider]
             [:h4 " Veranstaltungen"]
             [mui/list


              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :training-list)}
               [mui/list-item-icon [map]]
               [mui/list-item-text {:class ""} "Veranstaltungen Liste"]]


              [actual-training-selection-button]

              ]])

          (when (or (d-rights/allow-admin-for d-rights/CONTENT) (d-rights/allow-admin-for d-rights/LEBENSRETTER))
            [:div {:style {:background-color "#dbdcff"}}
             [mui/divider]
             [:h4 " Lebensretter"]
             [mui/list



              (when (d-rights/allow-admin-for d-rights/LEBENSRETTER)
                [mui/list-item
                 {:class   "admin-menu-item" :button true
                  :onClick #(a/set-page :lebensretter)}
                 [mui/list-item-icon [map-outlined]]
                 [mui/list-item-text {:class ""} "Lebensretter Teilnehmer"]])

              (when (d-rights/allow-admin-for d-rights/CONTENT)
                [mui/list-item
                 {:class   "admin-menu-item" :button true
                  :onClick #(a/set-page :lebensretter-feeds)}
                 [mui/list-item-icon [bookmark]]
                 [mui/list-item-text {:class ""} "Lebensretter Feeds"]])

              (when (d-rights/allow-admin-for d-rights/LR_INCIDENT)
                [mui/list-item
                 {:class   "admin-menu-item" :button true
                  :onClick #(a/set-page :lebensretter-incident)}
                 [mui/list-item-icon [map-outlined]]
                 [mui/list-item-text {:class ""} "Lebensretter Einsätze"]])


              (when (d-rights/allow-admin-for d-rights/LEBENSRETTER_ADMIN)
                [mui/list-item
                 {:class   "admin-menu-item" :button true
                  :onClick #(a/set-page :statistic-lr)}
                 [mui/list-item-icon [assessment]]
                 [mui/list-item-text {:class ""} "Lebensretter Statistik"]])

              (when (d-rights/is-superuser?)
                [mui/list-item
                 {:class   "admin-menu-item" :button true
                  :onClick #(a/set-page :lebensretter-optIn)}
                 [mui/list-item-icon [map-outlined]]
                 [mui/list-item-text {:class ""} "Lebensretter Opt-In"]])

              ]])

          ;[:div {:style {:background-color "#ffe6e6"}}
          ; [mui/divider]
          ; [:h4 " Nachbarschaftshilfe"]
          ; ]

          [:div {:style {:background-color "#e6f1ff"}}
           [mui/divider]
           [:h4 " Verwaltung"]
           [mui/list
            [mui/list-item
             {:class   "admin-menu-item" :button true
              :onClick #(a/set-page :my-setup)}
             [mui/list-item-icon [ic-bright/brightness-7]]
             [mui/list-item-text {:class ""} "Meine Einstellungen"]
             ]

            (when (d-rights/allow-admin-for d-rights/ADMIN)
              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :rights-manager)}
               [mui/list-item-icon [lock-open]]
               [mui/list-item-text {:class ""} "Rechteübersicht"]
               ])

            (when (d-rights/allow-admin-for d-rights/ADMIN_ORG)
              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :org-admin)}
               [mui/list-item-icon [group]]
               [mui/list-item-text {:class ""} "Dienststellen"]
               ])

            (when (d-rights/allow-admin-for d-rights/ADMIN_CONTENT)
              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :help-admin-list)}
               [mui/list-item-icon [help]]
               [mui/list-item-text {:class ""} "Hilfetexte"]
               ])

            (when (d-rights/allow-admin-for d-rights/ADMIN_CONTENT)
              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :text-blocks)}
               [mui/list-item-icon [format-align-left]]
               [mui/list-item-text {:class ""} "Vorlagen"]
               ])

            (when (d-rights/is-superuser?)
              [mui/list-item
               {:class   "admin-menu-item" :button true
                :onClick #(a/set-page :selectOptions)}
               [mui/list-item-icon [format-line-spacing]]
               [mui/list-item-text {:class ""} "Auswahlfelder"]
               ])
            ]
           ]

          ]
         )])))


;(in-ns 'teamoesterreich.admin-mode.navigation.drawer)
;(d-rights/allow-admin-for d-rights/LEBENSRETTER)





